import { uuidv4 } from '@/functions/utils/uuidv4'

export type SegmentBaseParams = {
  business_category: string | null
  country: string
  user_type: string
  user_id: string | null
  event_id: string
}

export type BuildSegmentBaseParamsInput = {
  country: string
  userId: string | null
  businessCategory: string | null
  userType: string
}

export function buildSegmentBaseParams (params: BuildSegmentBaseParamsInput): SegmentBaseParams {
  return {
    business_category: params.businessCategory,
    country: params.country,
    user_type: params.userType,
    user_id: params.userId,
    event_id: uuidv4(),
  }
}
